document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 749) {
    const footerBlocks = document.querySelectorAll("footer .footer-block");

    footerBlocks.forEach(block => {
      const title = block.querySelector(".footer-block__heading");
      if (!title) return;

      title.addEventListener("click", function () {
        block.classList.toggle("is-open");
      });
    });
  }
});